export const JSON_Bank_Ifcs10 = {
    "code": "0x0200",
    "message": "Record fetched successfully.",
    "status": "SUCCESS",
    "data": {
       "ocrRefId": "OCA80245647548293232E",
        "ocrStatus": "completed",
        "clientRefId": "OCRAAC123456",
        "extractionOutput": {
            "address": "/3 ,  S/O   Rajbabu Pal , ,/  Area/Locality/Sector   TURANG , , Village/ Town/City   Turang , District    ,  Puruliya , P.O.   Bijoydih , State  ,  West Benga , PinCode",
            "dateOfBirth": "",
            "district": "Puruliya",
            "fatherName": "Rajbabu Pal",
            "gender": "",
            "houseNumber": "",
            "idNumber": "434541045032",
            "nameOnCard": "Ajay Pal",
            "pincode": "723128",
            "state": "West Bengal",
            "streetAddress": "",
            "yearOfBirth": ""
        },
        "qrOutput": {
            "address": null,
            "dateOfBirth": null,
            "district": null,
            "gender": null,
            "houseNumber": null,
            "idNumber": null,
            "nameOnCard": null,
            "pincode": null,
            "state": null,
            "streetAddress": null,
            "yearOfBirth": null
        }
    }
};

export const JSON_Bank_Ifcs11 = {
    "code": "0x0202",
    "status": "FAILURE",
    "message": "Record not fetched.",
}


export const JSON_Bank_Ifcs12 = {
    "code": "0x0200",
    "message": "Record fetched successfully.",
    "status": "SUCCESS",
    "data": {
        "ocrRefId": "OCP80977570119731203490",
        "ocrStatus": "completed",
        "clientRefId": "OCRPAN56044",
        "extractionOutput": {
            "age": 29,
            "dateOfBirth": "1993-05-23",
            "dateOfIssue": "",
            "fatherName": "Rajbabu Pal",
            "idNumber": "ABCDE7445F",
            "minor": false,
            "nameOnCard": "Ajay Pal",
            "panType": "Individual"
    }
    }
};

export const JSON_Bank_Ifcs13 = {
    "code": "0x0202",
    "status": "FAILURE",
    "message": "Something went wrong"
}
